import { string, bool } from 'prop-types'
import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import PhoneNumber from 'components/common/phoneNumber'
import { LanguageContext } from 'context/LanguageContext'
import { getTheAppClicked } from 'modules/help/actions'
import { countryCode, getCurrentCountry } from 'utils/appUtils'
import constants from 'utils/constants'

export const SmartLinkComp = ({
    title,
    subtitle,
    disablePhone,
    inFooter,
    isProductDetails,
    isLocationModal,
    isWebsiteDown,
    inLandingPageBody,
}) => {
    const { strings } = useContext(LanguageContext)

    const dispatch = useDispatch()
    const locationInStore = useSelector(state => state.location)
    const userInStore = useSelector(state => state.user)
    const userCountry = getCurrentCountry(locationInStore, userInStore)
    const renderPhoneForm = () => (
        <form action="" className="download-our-app-form">
            <PhoneNumber
                wrapperClass="download-our-app-phone-number"
                labelText={subtitle}
                ariaLabel="phoneNumberLabel"
                showSendBtn={true}
                customCssFlag={inFooter}
                inLandingPageBody={inLandingPageBody}
            />
        </form>
    )

    const getUrl = () => {
        if (isWebsiteDown) {
            if (userCountry === countryCode.CA) {
                return constants.appDownloadCanadaURLBdy
            }
            return constants.appDownloadURLBdy
        } else if (isProductDetails) {
            if (userCountry === countryCode.CA) {
                return constants.productDetailsCanadaURLBdy
            }
            return constants.productDetailsURLBdy
        }
        if (userCountry === countryCode.CA) {
            return constants.appStoreSmartCanadaURLBdy
        }
        return constants.appStoreSmartURLBdy
    }
    const clickTheApp = () => dispatch(getTheAppClicked())

    const getFooterUrl = () => {
        if (userCountry === countryCode.CA) {
            return constants.appStoreCanadaSmartURLFtr
        }
        return constants.appStoreSmartURLFtr
    }
    return (
        <div className="download-our-app" tabIndex="0">
            {!isWebsiteDown && !isProductDetails && !isLocationModal && title && (
                <h4 className="download-our-app-title">{title}</h4>
            )}
            {!isWebsiteDown &&
                !isProductDetails &&
                !isLocationModal &&
                !disablePhone &&
                renderPhoneForm()}
            <div className={`download-our-app-stores ${isLocationModal ? 'marginTop' : null}`}>
                <button onClick={clickTheApp}>
                    <a
                        href={inFooter ? getFooterUrl() : getUrl()}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="download-our-app-stores-link"
                    >
                        <img
                            src={strings.FOOTER_DOWNLOAD_APP_STORE_IMAGE_LINK}
                            className="download-our-app-stores-link-logo"
                            alt="Download on the App Store"
                        />
                    </a>
                </button>
                <button onClick={clickTheApp}>
                    <a
                        href={inFooter ? getFooterUrl() : getUrl()}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="download-our-app-stores-link"
                    >
                        <img
                            src={strings.FOOTER_DOWNLOAD_GOOGLE_PLAY_IMAGE_LINK}
                            className="download-our-app-stores-link-logo"
                            alt="Get it on Google Play"
                        />
                    </a>
                </button>
            </div>
        </div>
    )
}

SmartLinkComp.propTypes = {
    title: string,
    subtitle: string,
    disablePhone: bool,
}

SmartLinkComp.defaultProps = {
    disablePhone: false,
}

export default SmartLinkComp
